import useFetch from "./useFetch";
import { useStateValue } from "../context-store/AppStateProvider";

const useTimezone = () => {
  const [{ userId }] = useStateValue();
  const endpointPath = `timezone/${userId}`;
  return useFetch(endpointPath);
};

export default useTimezone;
